import './_collection-messaging-block.scss';

export default () => {};
